import { z } from 'zod/v4';

export const platformCategoryOverrideSchema = z.object({
  name: z.string().min(1).optional(),
  isActive: z.boolean().optional(),
});

export const createCategorySchema = z.object({
  code: z.string().min(1).max(50),
  name: z.string().min(1).max(255),
});

export const orgCategoryOverrideSchema = z.object({
  name: z.string().min(1).optional(),
  isActive: z.boolean().optional(),
});
